import { AutocompleteItemType, EventType, HawksearchGlobal, PageType, SearchType } from '@models';
import { BaseService } from './base.service';

declare let Hawksearch: HawksearchGlobal;

export class TrackingService extends BaseService {
    protected baseUrl = Hawksearch.config.endpoints?.tracking || 'https://tracking-dev.hawksearch.net/api';

    trackAutocompleteClick(query: string, itemType: AutocompleteItemType, title: string, url: string): Promise<void> {
        const data = {
            Keyword: query,
            Name: title,
            SuggestType: itemType,
            Url: url
        };

        return this.trackEvent(EventType.AutocompleteClick, data);
    }

    trackBannerClick(bannerId: number, campaignId: number): Promise<void> {
        if (!Hawksearch.searchResponse?.trackingId) {
            return Promise.resolve();
        }

        const data = {
            BannerId: bannerId,
            CampaignId: campaignId,
            TrackingId: Hawksearch.searchResponse.trackingId
        };

        return this.trackEvent(EventType.BannerClick, data);
    }

    trackBannerImpression(bannerId: number, campaignId: number): Promise<void> {
        if (!Hawksearch.searchResponse?.trackingId) {
            return Promise.resolve();
        }

        const data = {
            BannerId: bannerId,
            CampaignId: campaignId,
            TrackingId: Hawksearch.searchResponse.trackingId
        };

        return this.trackEvent(EventType.BannerImpression, data);
    }

    trackPageLoad(pageType: PageType): Promise<void> {
        const data = {
            PageTypeId: pageType,
            RequestPath: window.location.pathname,
            Qs: window.location.search,
            ViewportHeight: document.documentElement.clientHeight,
            ViewportWidth: document.documentElement.clientWidth
        };

        return this.trackEvent(EventType.PageLoad, data);
    }

    trackSearchResultClick(id: string, url: string, event?: PointerEvent): Promise<void> {
        if (!Hawksearch.searchResponse?.trackingId) {
            return Promise.resolve();
        }

        const data = {
            UniqueId: id,
            Url: url,
            TrackingId: Hawksearch.searchResponse.trackingId,
            RequestPath: window.location.pathname,
            Qs: window.location.search,
            ScrollX: window.scrollX,
            ScrollY: window.scrollY,
            ViewportHeight: document.documentElement.clientHeight,
            ViewportWidth: document.documentElement.clientWidth,
            MouseX: event?.pageX,
            MouseY: event?.pageY
        };

        return this.trackEvent(EventType.Click, data);
    }

    trackSearch(query: string | undefined, newSearch: boolean): Promise<void> {
        if (!Hawksearch.searchResponse?.trackingId) {
            return Promise.resolve();
        }

        const data = {
            QueryId: newSearch ? this.setNewQueryId() : this.getQueryId(),
            TrackingId: Hawksearch.searchResponse.trackingId,
            TypeId: newSearch ? SearchType.Initial : SearchType.Refinement,
            ViewportHeight: document.documentElement.clientHeight,
            ViewportWidth: document.documentElement.clientWidth,
            keyword: query
        };

        return this.trackEvent(EventType.Search, data);
    }

    trackEvent(type: EventType, data: any): Promise<void> {
        if (Hawksearch.config.trackingEnabled === false) {
            return Promise.resolve();
        }

        const request = {
            ClientGuid: Hawksearch.config.clientId,
            EventType: type,
            EventData: btoa(JSON.stringify(data)),
            VisitorId: this.getVisitorId(),
            VisitId: this.getVisitId()
        };

        return this.httpPost<void>('/trackevent', request);
    }

    private getQueryId(): string {
        const key = 'QueryId';

        let queryId = localStorage.getItem(key);

        if (!queryId) {
            queryId = this.setNewQueryId();
        }

        return queryId;
    }

    private setNewQueryId(): string {
        const queryId = this.generateGuid();

        localStorage.setItem('QueryId', queryId);

        return queryId;
    }
}

export const trackingService = new TrackingService();
